export interface TargetingDecision {
    name: string | null;
    sample_rate: number;
}

export interface TargetingAPIResult extends TargetingDecision {
    ttl: number;
}

export default class TargetingService {
    private host: string;

    constructor(host: string) {
        this.host = host;
    }

    public async getTargetingInfo(): Promise<TargetingAPIResult> {
        const res = await fetch(`${process.env.API_HOST!}/gp/vibes/api/survey`, {
            redirect: "error",
            headers: {
                'Accept': "application/json",
                'X-Requested-With': 'XMLHttpRequest', // MONS marks requests with this header as AJAX requests and handles things differently, like authentication errors
            }
        });

        if (!res.ok) {
            throw new Error("Received a non-200 status from Targeting API");
        }

        let body: TargetingAPIResult;
        try {
            body = await res.json();
        } catch (e) {
            throw new Error(`Could not parse targeting response body, status code: ${res.status}`);
        }

        const keys = Object.keys(body);
        if (!keys.includes('name') || !keys.includes('ttl') || !keys.includes('sample_rate')) {
            throw new Error(`Received invalid response body from Targeting API with status code ${res.status}`);
        }


        return body;
    }
}
